import React, { FC } from "react";
import { backgroundLocationState } from "containers/Routes/backgroundLocation";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { authSelectFullName } from "../../reduxFolder/selectors/globalSelectors";
import {
  GearFillIcon,
  SignOutFillIcon,
} from "../LeftMenu/IconsComponents/IconsComponents";
import {
  FooterName,
  FooterRow,
  LogoutButton,
  SettingsLink,
} from "./UserInfo.styles";

interface UserInfoProps {
  fullName: string | null;
  onNavigate?: () => void;
}

// Nav footer: the settings link (the user's name behind a gear) and sign out.
// The link opens /account as a dialog over the current page, passed along as
// the background location. useLocation here is the page tree's scoped
// location, which is the right one either way: the real one while no dialog
// is open, the page underneath while one is.
const UserInfo: FC<UserInfoProps> = React.memo(({ fullName, onNavigate }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation("common");

  const handleLogout = () => {
    navigate("/logout");
  };

  return (
    // LeftMenu also mounts on public routes, where there is no user.
    <FooterRow style={{ visibility: fullName ? "visible" : "hidden" }}>
      <SettingsLink
        to="/account"
        state={backgroundLocationState(location)}
        onClick={onNavigate}
        title={t("pages.settings")}
        aria-label={`${t("account.settings")}: ${fullName ?? ""}`}
      >
        <GearFillIcon />
        <FooterName>{fullName}</FooterName>
      </SettingsLink>
      <LogoutButton
        onClick={handleLogout}
        title={t("pages.signout")}
        aria-label={t("pages.signout")}
      >
        <SignOutFillIcon />
      </LogoutButton>
    </FooterRow>
  );
});

const withConnect = connect(
  createStructuredSelector({
    fullName: authSelectFullName,
  }),
);

export default withConnect(UserInfo);
